
import { AssetEntityDecorator } from './asset.decorator';
import { Asset } from './asset.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AssetTypeInfoBase implements CrudTypeInfo<Asset, number> {
  name = 'Asset';
  entityDecorator = new AssetEntityDecorator();
  
  createAuthorities = ['WRITE_ASSET'];
  editAuthorities = ['WRITE_ASSET'];
  deleteAuthorities = ['DELETE_ASSET'];
  viewAuthorities = ['READ_ASSET'];
  
  searchRouteBase = ['/asset/search'];
  createRouteBase = ['/asset/create'];
  editRouteBase = ['/asset/edit'];
  viewRouteBase = ['/asset/view'];
  
  description(item: Asset): string {
    return '' +  item.assetId +  ' - ' +  item.description;
  }
}



